<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="Beschreibung basierend auf dem Zahlungsdienstegesetz" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Name des Betreiberunternehmens</span>
            <span class="text">Hatchi Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">repräsentative Person</span>
            <span class="text">Ken Yatsuka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Firmenregistrierungsadresse/Geschäftssitzadresse</span>
            <span class="text">547-0011</span>
            <span class="text">3-39 Nagayoshi Deto 7-chome, Hirano-ku, Osaka City, Präfektur Osaka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Besitzgrenze/-dauer der Münze (Währung auf dieser Seite).</span>
            <span class="text">Es gibt keine Obergrenze für Münzen.</span>
            <span class="text">Wenn jedoch seit der letzten Verwendung von Coins (einschließlich des Tages) 6 Monate vergangen sind, ohne dass diese nach dem Kauf oder Umtausch von Coins verwendet wurden, können wir Ihr Konto löschen, ohne Sie vorher zu benachrichtigen.</span>
            <span class="text">In diesem Fall wird der Coin ungültig.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Standortbereich der Münzverwendung</span>
            <span class="text">Es gibt keine Obergrenze für Münzen.</span>
            <span class="text">Münzen (Währung auf dieser Website) können innerhalb des registrierten Kontos verwendet werden.</span>
            <span class="text">Darüber hinaus ist die Übertragung von Konten und die Übertragung von Coins untersagt.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Vorsichtsmaßnahmen für den Gebrauch</span>
            <span class="text">Münzen (Währung auf dieser Website) können nicht erstattet werden.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">So überprüfen Sie die Münzen, die Sie besitzen</span>
            <span class="text">Sie können es auf dem Bildschirm dieser Website überprüfen.</span>
            <span class="text">Wenn sich die Münzen, die Sie besitzen, bewegen, ändert sich die Anzahl automatisch.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Kontaktinformationen</span>
            <span class="text">Bitte kontaktieren Sie uns hier.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nutzungsbedingungen</span>
            <span class="text">Bitte überprüfen Sie die Nutzungsbedingungen dieser Website.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
